import { lazy } from 'react';

export const BoostCheckoutPageLazy = lazy(
    () => import('./boost-checkout-page'),
);
